import { z } from 'zod';

const signingSchema = z.object({
    algorithm: z.string().optional(),
    secret: z.string().optional(),
    previousSecret: z.string().optional(),
});

const retrySchema = z.object({
    maxAttempts: z.coerce.number().int().min(1).max(20).optional(),
    backoffMs: z.coerce.number().int().min(100).optional(),
    backoffStrategy: z.enum(['exponential', 'linear']).optional(),
});

const filterSchema = z.object({
    expression: z.string().optional(),
});

export const webhookSubscriptionCreateSchema = z.object({
    name: z.string().min(1).max(200),
    eventPattern: z.string().min(1).max(500),
    urlTemplate: z.string().min(1).max(4000),
    method: z.enum(['POST', 'PUT', 'PATCH']).optional(),
    headers: z.record(z.string(), z.string()).optional(),
    bodyTemplate: z.string().max(100000).optional(),
    retry: retrySchema.optional(),
    signing: signingSchema.optional(),
    filter: filterSchema.optional(),
    enabled: z.boolean().optional(),
});

export const webhookSubscriptionUpdateSchema = webhookSubscriptionCreateSchema.partial();

export const webhookDeliveriesListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).optional().default(1),
    pageSize: z.coerce.number().int().min(1).max(100).optional().default(20),
    success: z.enum(['true', 'false']).optional(),
});
